import { forwardRef } from 'react';

import { IconProps } from '.';

export const WalletIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M15.38 11.4401C15.38 12.0641 14.8741 12.5701 14.25 12.5701C13.6259 12.5701 13.12 12.0641 13.12 11.4401C13.12 10.816 13.6259 10.3101 14.25 10.3101C14.8741 10.3101 15.38 10.816 15.38 11.4401Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 5V5.88C16.9385 6.03502 17.3181 6.3221 17.5867 6.70174C17.8554 7.08139 17.9997 7.53494 18 8V15C18 15.5967 17.7629 16.169 17.341 16.591C16.919 17.0129 16.3467 17.25 15.75 17.25H4.25C3.65326 17.25 3.08097 17.0129 2.65901 16.591C2.23705 16.169 2 15.5967 2 15V5C2 4.40326 2.23705 3.83097 2.65901 3.40901C3.08097 2.98705 3.65326 2.75 4.25 2.75H14.25C14.8467 2.75 15.419 2.98705 15.841 3.40901C16.2629 3.83097 16.5 4.40326 16.5 5ZM14.25 4.25H4.25C4.05109 4.25 3.86032 4.32902 3.71967 4.46967C3.57902 4.61032 3.5 4.80109 3.5 5C3.5 5.19891 3.57902 5.38968 3.71967 5.53033C3.86032 5.67098 4.05109 5.75 4.25 5.75H15V5C14.9974 4.80189 14.9176 4.61263 14.7775 4.47253C14.6374 4.33244 14.4481 4.25259 14.25 4.25ZM16.2803 15.5303C16.421 15.3897 16.5 15.1989 16.5 15V8C16.4974 7.80189 16.4176 7.61263 16.2775 7.47253C16.1374 7.33244 15.9481 7.25259 15.75 7.25H4.25C3.99455 7.24825 3.74114 7.20433 3.5 7.12V15C3.49865 15.0989 3.51714 15.197 3.55435 15.2886C3.59156 15.3802 3.64676 15.4634 3.71667 15.5333C3.78659 15.6032 3.8698 15.6584 3.9614 15.6957C4.05301 15.7329 4.15114 15.7513 4.25 15.75H15.75C15.9489 15.75 16.1397 15.671 16.2803 15.5303Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default WalletIcon;
